/**
 * Different origin applications, the user navigated to the self-service from.
 */
export enum SourceAppEnum {
    UNKNOWN = 'unknown',
    S24 = 's24',
    GEORGE = 'george',
    CPS = 'cps'
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/core/model/source-app.enum.ts